import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const StripeConnectedAccountFormPage = () =>
  import('@modules/stripe/stripe-connected-account/components/stripe-connected-account-form-page.vue');

export default [{
  name: '',
  path: '',
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      name: 'stripeConnectedAccountCreate',
      path: '/subproperty/settings/finantial/account/new',
      component: StripeConnectedAccountFormPage,
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
    },
    {
      name: 'stripeConnectedAccountEdit',
      path: '/subproperty/settings/finantial/account/:id/edit',
      component: StripeConnectedAccountFormPage,
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
      props: true,
    },
  ],
}];
